import state from './moduleEcoShipState.js'
import mutations from './moduleEcoShipMutations.js'
import actions from './moduleEcoShipActions.js'
import getters from './moduleEcoShipGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}